import { InvoicesStore } from '../stores/invoices';
import { setUiTotal } from './ui';
import { apiManager } from '../REST';
import { IBodyListResponse, IInvoice, IInvoiceAPI, IInvoicesList, IParamsList } from '../interfaces';
import { cleanBillingSystemStore, getBillingCompaniesSelect } from '../middleware';
import { mapApi2UiField } from '../instruments';

const mapItem = (i: IInvoiceAPI): IInvoice => {
    const invoice: IInvoice = { id: i.id, ...mapApi2UiField(i || {}) };
    invoice.sellerId = invoice.sellerId || i.seller.id;
    invoice.buyerId = invoice.buyerId || i.buyer.id;
    invoice.buyer = i.buyer.name;
    invoice.seller = i.seller.name;
    return invoice;
};

// ------------ List ------------
const setInvoicesList = (list: IInvoicesList): void => {
    const StoreInstance = InvoicesStore.getInstance();
    StoreInstance.setList(list);
};

export function setInvoicesForcedUpdateTime(): void {
    const StoreInstance = InvoicesStore.getInstance();
    StoreInstance.setForcedUpdateTime();
}

export async function getInvoicesList(params: IParamsList): Promise<void> {
    const { resp } = await apiManager.getApi('GET_INVOICES_LIST', { searchParamsList: params });
    const { invoices, meta } = resp as IBodyListResponse;
    setUiTotal(meta?.records_count);
    if (invoices) {
        const list = invoices.map((i: IInvoiceAPI) => mapItem(i));
        setInvoicesList(list);
    } else {
        setInvoicesList([]);
    }
}

export async function getLastInvoice(params: IParamsList): Promise<IInvoice | void> {
    const { resp } = await apiManager.getApi('GET_INVOICES_LIST', { searchParamsList: params });
    const { invoices } = resp as IBodyListResponse;
    if (invoices) {
        const list = invoices.map((i: IInvoiceAPI) => mapItem(i));

        return list[0];
    }
}

export function cleanInvoicesStore(): void {
    const StoreInstance = InvoicesStore.getInstance();
    StoreInstance.cleanStore();
}

export async function getInvoicesRelationSelect(): Promise<void> {
    getBillingCompaniesSelect();
}

export function cleanInvoicesRelationSelectAndStore(): void {
    cleanInvoicesStore();
    cleanBillingSystemStore();
}

// ------------ Item ------------

const setInvoice = (item: IInvoice): void => {
    const StoreInstance = InvoicesStore.getInstance();
    StoreInstance.setItem(item);
};

export async function getInvoiceById(id: string): Promise<boolean> {
    const { resp, isError } = await apiManager.getApi('GET_INVOICE', { id: id });
    if (!isError && resp?.invoice?.id) {
        setInvoice(mapItem(resp?.invoice));
    }
    return !isError;
}

export function cleanInvoiceStore(): void {
    const StoreInstance = InvoicesStore.getInstance();
    StoreInstance.cleanItem();
}
